import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import {
  listStaff,
  listStaffByGroupId,
  listStaffOnline,
  readStaff,
} from "./thunkAction";

const initialState = {
  staff: {},
  staffs: {},
  staffGroups: {},
  listStaffOnline: [],
  loading: false,
  error: null,
};

const staffSlice = createSlice({
  name: "staffManage",
  initialState,
  reducers: {
    clearStaff(state) {
      state.staff = {};
      state.staffs = {};
      state.staffGroups = [];
    },
    resetProfileError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // readStaff
      .addCase(readStaff.pending, (state) => {
        state.loading = true;
      })
      .addCase(readStaff.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        const staff = _.get(action, "payload", {});
        const staffId = _.get(staff, "_id");
        state.staff = staff;
        if (staffId) {
          state.staffs[staffId] = staff;
        }
      })
      .addCase(readStaff.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // listStaff
      .addCase(listStaff.pending, (state) => {
        state.loading = true;
      })
      .addCase(listStaff.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        const staffs = _.get(action, "payload", []);
        _.map(staffs, (staff) => {
          const staffId = _.get(staff, "_id");
          state.staffs[staffId] = staff;
        });
      })
      .addCase(listStaff.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // listStaffOnline
      .addCase(listStaffOnline.pending, (state) => {
        state.loading = true;
      })
      .addCase(listStaffOnline.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.listStaffOnline = _.get(action, "payload", []);
      })
      .addCase(listStaffOnline.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // listStaffByGroupId
      .addCase(listStaffByGroupId.pending, (state) => {
        state.loading = true;
      })
      .addCase(listStaffByGroupId.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        const staffs = _.get(action, "payload", []);
        state.staffGroups = staffs;
      })
      .addCase(listStaffByGroupId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const staffReducer = staffSlice.reducer;

export const staffAction = staffSlice.actions;
